import { render, staticRenderFns } from "./Historical_data.vue?vue&type=template&id=1684ef40&"
import script from "./Historical_data.vue?vue&type=script&lang=js&"
export * from "./Historical_data.vue?vue&type=script&lang=js&"
import style0 from "./Historical_data.vue?vue&type=style&index=0&id=1684ef40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports